import { flowRight } from 'lodash/fp';
import React from 'react';
import PropTypes from 'prop-types';
import { pure } from 'recompose';
import { Action, Actions, Date, Initials, Item, connectActiveItem } from '../list';
import { withSession } from '../sessions';
import './ListItemTopinvest.scss';
import getUrlTopinvest from './utils/getUrlTopinvest';

const ListItemTopinvest = ({ rip, item, show, isActive, session }) => {
    const mayWrite = session.permissions.mayWriteOnSimulation(rip, item);
    const [isLoading, setIsLoading] = React.useState(false);

    const handleOpenSimulation = async () => {
        setIsLoading(true);
        try {
            const data = await getUrlTopinvest({
                idSimulation: item.IdSimulation,
                idFoyerFiscal: item.IdFoyerFiscal,
                beneficiary: item.beneficiary,
                ripId: rip.id,
            });

            if (data && data.simulationUrl) {
                window.open(data.simulationUrl, '_blank');
                setIsLoading(false);
            }
        } catch (error) {
            console.error('Erreur lors de l\'ouverture de la simulation TopInvest:', error);
            setIsLoading(false);
        }
    };

    return (
        <Item
            displayActions={isActive}
            onFocus={!isActive ? () => show() : null}
        >
            <Initials firstName={rip.firstName} lastName={rip.lastName} />
            <td>{item.Nom || ''}</td>
            <td>{item.LibelleTypeSimulation || ''}</td>
            <td>{item.IntituleFoyerFiscal || ''}</td>
            <Date date={item.DateCreation} />
            <Date date={item.DateModification} />

            <Actions>
                {mayWrite && (
                    <Action
                        onClick={handleOpenSimulation}
                        icon={isLoading ? 'spinner' : 'pencil'}
                        text="modifier"
                        className={isLoading ? 'spinner' : ''}
                    />
                )}
            </Actions>
        </Item>
    );
};

ListItemTopinvest.propTypes = {
    rip: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        id: PropTypes.string,
    }).isRequired,
    item: PropTypes.shape({
        IdSimulation: PropTypes.number,
        IdFoyerFiscal: PropTypes.number,
        Nom: PropTypes.string,
        LibelleTypeSimulation: PropTypes.string,
        IntituleFoyerFiscal: PropTypes.string,
        DateCreation: PropTypes.string,
        DateModification: PropTypes.string,
        beneficiary: PropTypes.string,
        id: PropTypes.number,
    }).isRequired,
    isActive: PropTypes.bool.isRequired,
    show: PropTypes.func.isRequired,
    session: PropTypes.shape({
        permissions: PropTypes.shape({
            mayWriteOnSimulation: PropTypes.func,
        }),
    }).isRequired,
};

export default flowRight([
    connectActiveItem(
        ({ item: { id } }) => id,
        (item, { activeItem }) => ({ isActive: item === activeItem }),
    ),
    pure,
    withSession,
])(ListItemTopinvest);
